module.exports = __webpack_public_path__ + "static/img/nanchang.4d28e68.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/nanchang.png
// module id = 1y40
// module chunks = 1